<template>
  <div class="buyone-wrap">
    <app-header />
    <div class="auto">
      <div class="price" @click="goUrl(116)">
        <h2>到手价998</h2>
        <p>活动期限：2021.04.19至2021.05.31</p>
      </div>
      <p class="tel-top">咨询热线：021-20219999</p>
      <div class="mod-tab">
        <div class="mod" @click="curIndex = 0" :class="{cur: curIndex === 0}">
          <div class="title">
            <div class="con">
              <img src="../../assets/images/activity/buyone365/icon-computer.png">电脑端功能全面升级
            </div>
          </div>
          <ul>
            <li><p>LEVEL2全推高速行情</p></li>
            <li><p>资金流向</p></li>
            <li>
              <p>特色指标战法选股</p>
              <span>四维战法/波段线/TRT/黄金坑</span>
              <strong>价值￥998/年</strong>
            </li>
          </ul>
          <div class="text">电脑端功能<em>详细介绍</em><img src="../../assets/images/activity/buyone365/icon-down.png"></div>
        </div>
        <div class="mod" @click="curIndex = 1" :class="{cur: curIndex === 1}">
          <div class="title">
            <div class="con">
              <img src="../../assets/images/activity/buyone365/icon-phone.png">移动端两大战法
            </div>
          </div>
          <ul>
            <li><p>《主力筹码追踪》<em>筹码峰值战法</em>
              <strong>价值￥888/年</strong>
            </p></li>
            <li><p>《双突战法》<em>分时高能突击</em>
              <strong>价值￥88/年</strong>
            </p></li>
          </ul>
          <div class="text">移动端功能<em>详细介绍</em><img src="../../assets/images/activity/buyone365/icon-down.png"></div>
        </div>
      </div>
    </div>
    <div class="computer-con" v-show="curIndex === 0">
      <div class="header-level2">
        <div class="header-con">
            <span>沪深交易所授权高速行情</span>
          <h1>Level2功能全面升级</h1>
        </div>
      </div>
      <div class="conputer-wrap">
        <div class="main-con">
          <div class="pankou clearfix">
            <div class="clearfix">
              <div class="pankou-l">
                <h3 class="title">L2盘口(最低仅需￥998/年)</h3>
              </div>
              <div class="pankou-r">
                <h3 class="title">DDX排行TOP20(实时)及个股DDE数据</h3>
              </div>
            </div>
            <img src="../../assets/images/activity/buyone365/img01-1.jpg" alt="">
          </div>
          <div class="auto-computer">
            <div class="mid-bar1"><img src="../../assets/images/activity/buyone365/mid-bar1.jpg"></div>
          <div class="mid-bar2"><img src="../../assets/images/activity/buyone365/mid-bar2.jpg"></div>
          <div class="tab-tit">
            <ul class="clearfix">
              <li v-for="(li,index) in liData" :key="index" :class="{cur: index === comIndex}" @click="changeComputer(index)">{{li}}</li>
            </ul>
          </div>
          <div class="tab-main" ref="tabMain">
            <div class="tab-con clearfix" ref="tabCon">
              <div class="item">
                    <dl>
                      <dt>交易数据，一览无余</dt>
                      <dd><img src="../../assets/images/activity/buyone365/img1-1.png" class="ml0 mauto"></dd>
                      <dd class="border-none"><img src="../../assets/images/activity/buyone365/img1-2.png" class="ml0 mauto"></dd>
                    </dl>
              </div>
              <div class="item">
                    <dl>
                      <dt>盘口挂单，尽收眼底</dt>
                      <dd>
                            <p class="title">买卖队列揭示买一卖一位置前50笔挂单详情，是散户小打小闹，还是主力真刀真枪在干，一览无余。</p>
                            <img src="../../assets/images/activity/buyone365/img2-1.png">
                      </dd>
                      <dd>
                            <p class="title">深市全息盘口千档挂单全部展示（最右侧）；另有完整逐笔成交数据（中间）</p>
                            <img src="../../assets/images/activity/buyone365/img2-2.png">
                      </dd>
                      <dd class="border-none">
                            <p class="title">单击深市全息盘口千档挂单（最右侧）任意一行，查看该档委托单明细，是庄家还是散户，一看便知</p>
                            <img src="../../assets/images/activity/buyone365/img2-3.png">
                      </dd>
                    </dl>
              </div>
              <div class="item">
                    <dl>
                      <dt>历史回忆，复盘利器</dt>
                      <dd>
                            <p class="title mb0">动态显示牌或者个股界面上可按【Alt＋Left】或【Alt＋Right】。<br>
                            打开历史回忆功能，就可回到过去的某个交易日，系统将回送那个交易日的动态显示牌、股票的分时图、分笔成交图等等。level2的十档买卖盘、逐笔成交，分时level2指标、分笔成交、当日行情涨幅排行等等数据都可以回放。复盘利器名副其实。</p>
                      </dd>
                      <dd>
                            <p class="title">下图为个股图形界面历史回忆</p>
                            <img src="../../assets/images/activity/buyone365/img3-1.png">
                      </dd>
                      <dd class="border-none">
                            <p class="title">下图为动态显示牌(报价牌)界面历史回忆</p>
                            <img src="../../assets/images/activity/buyone365/img3-2.png">
                      </dd>
                    </dl>
              </div>
              <div class="item">
                    <dl>
                      <dt>主力资金，无所遁形</dt>
                      <dd>
                            <p class="title">SV资金流是大智慧新一代基于level2深度数据，实时跟踪控盘资金在板块、个股间流动情况的功能模块。逐单统计后的SV资金流数据可以向用户清晰地展示主力的操作方向，帮助用户快速捕捉热点板块和强势股。<span class="blue">(本功能在大智慧专业版及以上版本开放)</span></p>
                            <img src="../../assets/images/activity/buyone365/img4-1.png"><br>
                            <p class="mb0">DDE决策系统：包含DDE分析模板、DDE指标排行、主力资金线、超赢实时监控、分时DDX、逐单(笔)资金、资金夹角、总买总卖、成交单数等。</p>
                      </dd>
                      <dd>
                            <p class="title">下图为DDE指标排行界面，当日、最近5日、60日资金关注哪些股票，一点即知。</p>
                            <img src="../../assets/images/activity/buyone365/img4-2.png">
                      </dd>
                      <dd>
                            <p class="title">下图为DDE指标界面，个股DDE指标金叉关注，死叉注意风险</p>
                            <img src="../../assets/images/activity/buyone365/img4-3.png">
                      </dd>
                      <dd class="border-none">
                            <p class="title">下图为个股超赢实时监控界面，历史上每一天是散户流出，还是超大户流出，一目了然。<span class="blue">(本功能在大智慧专业版及以上版本开放)</span></p>
                            <img src="../../assets/images/activity/buyone365/img4-4.png">
                      </dd>
                    </dl>
              </div>
              <div class="item">
                    <dl>
                      <dt>追击反转</dt>
                      <dd>
                            <p class="title">精明的资金总是在股价下跌末期开始介入，从而在成本上较后知后觉者有较大的优势。本指标就是在这一规律上开发，综合利用资金流分析，价格分析，争取在第一时间发现精明资金的动向。把握了精明资金的进入节奏，破解个股反弹的财富密码。<br><span class="blue">用法：</span>黄色柱子代表精明资金开始介入，柱子的长短代表资金介入的多少。红色柱子为反转信号短线机会点黄色柱子代表吸筹量。主力吸货是需要时间的，因此切勿一看到主力入场，就杀进去，耐心等待吸筹量达到一个峰值，且开始转向时介入，才是正确的方法。</p>
                      </dd>
                      <dd class="border-none">
                            <p class="title">以下图片为功能案例：</p>
                            <img src="../../assets/images/activity/buyone365/img5-1.png" class="mb30">
                            <img src="../../assets/images/activity/buyone365/img5-2.png" class="mb30">
                            <img src="../../assets/images/activity/buyone365/img5-3.png">
                      </dd>
                    </dl>
              </div>
              <div class="item">
                    <dl>
                      <dt>抄底资金</dt>
                      <dd>
                            <p class="title mb0">该指标适合于处于长期上行趋势中出现的回调或震荡走势；不适合向下和窄幅震荡的行情；<br>
                              1、当黄色实线下穿进入机会区(红色点状线)时，表示股价已经超跌，短期或迎来向上反弹行情。若出现红色箭头，则表示该区域为短期底部的概率很大。<br>
                              2、当黄色实线上穿进入风险区(绿色点状线)，表示股价已经超涨，该区域风险加大，不宜追高；<br>
                              3、条件选股时，选择X大于0，使用除权后数据，分析周期用日线周期。</p>
                      </dd>
                      <dd class="border-none">
                            <p class="title">以下图片为功能案例：</p>
                            <img src="../../assets/images/activity/buyone365/img6-1.png" class="mb0">
                            <img src="../../assets/images/activity/buyone365/img6-2.png" class="mb0">
                            <img src="../../assets/images/activity/buyone365/img6-3.png">
                      </dd>
                    </dl>
              </div>
              <div class="item">
                    <dl>
                      <dt>双突战法</dt>
                      <dd>
                            <p class="title mb0">本指标是大智慧的特色功能，适合在分时周期使用，重在监控每日盘中放量突破的个股，成功率非常高，适合短线投资者。<br>
                              1、个股当天第一波放量上涨，定义为【一突】<br>
                              2、出现一突信号的个股，经过盘整再次放量上涨为【双突】可以结合个股日K线形态和大盘强弱进行短线操作。</p>
                      </dd>
                      <dd class="border-none">
                            <p class="title">以下图片为功能案例：</p>
                            <img src="../../assets/images/activity/buyone365/img7-1.png" class="mb30">
                            <img src="../../assets/images/activity/buyone365/img7-2.png" class="mb30">
                            <img src="../../assets/images/activity/buyone365/img7-3.png">
                      </dd>
                    </dl>
              </div>
              <div class="item"><dl>
                    <dt>黄金坑2.0</dt>
                      <dd>
                            <p class="title mb0">个股前期经过较长时间的横盘和小角度上行或者大幅度的下杀之后，主力在确定拉升行情前，借助大盘回调或市场非理性利空因素进行一轮短暂快速的杀跌，引发在横盘等待的跟风者和不坚定持仓者下马，将不坚定的筹码洗出去，以减少自己的拉升阻力，然后反手做多，脱离成本区，股价便迅速从坑中拔地而起，一波波澜壮阔的行情随之展开，在K线图上就形成了一个形似坑状的图型叫黄金坑。<br>
                              <span class="blue">指标原理：</span><br>
                              新黄金坑基于投资品种趋势和量价分析特点，是一个趋于短中线性质的技术指标。<br>
                              该指标由H1，H2，H3三条趋势线和动态建仓以及波段低位和主力建仓提醒组成，其中的建仓模型主要是根据走势以及成本筹码分析，而新黄金坑的形成由趋势反转的提醒功能。<br>
                              <span class="blue">指标用法：</span><br>
                              （1）：H1、H2、H3三线持续向上短期有反转，股价有持续的上涨动力。<br>
                              （2）：H1、H2、H3三线金叉多头向上，为短期反弹趋势<br>
                              （3）：黄色毛刷状“黄金坑”形态出现，为中期黄金坑形态形成标志。<br>
                              （4）：当出现红色波段低位线的时候，意味着短期下跌遇到支撑，股价可能还会持续下跌，但是即将回稳。<br>
                              （5）：当出现主力建仓为负值时，意味着筹码分析上看有资金逐步介入。</p>
                      </dd>
                      <dd class="border-none">
                            <p class="title">以下图片为功能案例：</p>
                            <img src="../../assets/images/activity/buyone365/img8-1.png" class="mb30">
                            <img src="../../assets/images/activity/buyone365/img8-2.png" class="mb30">
                            <img src="../../assets/images/activity/buyone365/img8-3.png">
                      </dd>
                    </dl>
              </div>
              <div class="item">
                    <dl>
                        <dt>TRT顺势交易</dt>
                        <dd>
                            <p class="title mb0">TRT包括3大功能：明日交易提示、趋势提示、短期多空提示。<br>
                        1、明日操盘提示。在K线图中以文字形式并结合量能来提示明日操作思路 。<br>
                        2、趋势提示。红色K线代表上升趋势，蓝色K线代表下跌趋势。在上涨趋势中出现红包绿K线为主力震仓行为，避免错失波段行情，反之在下跌趋势中出现空心绿线为反抽行情，切勿进入。<br>
                        3、B点S点短期多空提示信号，B点为短期偏多转折信号即将步入看多区间，S点为短期偏空转折信号即将步入看空通道中。</p>
                        </dd>
                        <dd class="border-none">
                            <p class="title">以下图片为功能案例：</p>
                            <img src="../../assets/images/activity/buyone365/img9-1.jpg" class="mb30">
                            <img src="../../assets/images/activity/buyone365/img9-2.jpg" class="mb30">
                            <img src="../../assets/images/activity/buyone365/img9-3.jpg">
                        </dd>
                    </dl>
              </div>
              <div class="item">
                    <dl>
                        <dt>短舱波动</dt>
                        <dd>
                            <p class="title mb0">短仓波动基于大智慧筹码分析功能，是一个短中线兼顾的技术指标，投资者在使用的时候可以用适当的仓位进行波段操作。<br>
                            D1线表示短线资金的攻击力度，D2线表示长线资金的攻击力度。当D1线从下方金叉D2线的时候意味着短期短线资金攻击力度大于长线资金攻击力度，将会在低位出现红柱，为向信号，同时指标彩带为红色，表示该区域以做多为主。当D1线从上方下穿D2线的时候意味着短线资金大幅度流出，指标彩带为绿色，由多转空，表示该区域以规避为主。当出现蓝柱，同时，紫色网格状为底部区域，当底部区域出现的时候意味着做空动能衰竭，标的有逐步止跌反攻的意愿。<br>
                            <span class="blue">用法:</span><br>
                                1）红色彩带上穿超买线（数值80），风险较高，如果个股有转弱，可考虑控制风险；<br>
                                2）绿色彩带跌穿见底线（数值20）同时出现网格状底部区域，抄底机会大；<br>
                                3）当低位出现红柱，为向上信号，同时指标彩带为红色，表示该区域以做多为主<br>
                                4）当彩带为绿色，由多转空，表示该区域以规避为主。</p>
                        </dd>
                        <dd class="border-none">
                            <p class="title">以下图片为功能案例：</p>
                            <img src="../../assets/images/activity/buyone365/img10-1.png" class="mb30">
                            <img src="../../assets/images/activity/buyone365/img10-2.png" class="mb30">
                            <img src="../../assets/images/activity/buyone365/img10-3.png">
                        </dd>
                    </dl>
              </div>
            </div>
          </div>
          </div>
        </div>
        <div class="tel"><img src="../../assets/images/activity/buyone365/tel.png" alt=""></div>
      </div>
    </div>
    <div class="phone-con" v-show="curIndex === 1">
      <h2 class="header-phone"><span>《主力筹码追踪》筹码峰值战法</span></h2>
      <dl>
        <dt>峰值原理</dt>
        <dd>
          <p><em>1</em>悬停在个股K线图任意某日即可查看主力筹码追踪图，横向长度为筹码量，纵向高度为对应股价。</p>
          <img src="../../assets/images/activity/buyone365/img-p1-1.jpg" alt="">
        </dd>
        <dd>
          <p><em>2</em>深度解析主力资金异动迹象，含低位吸筹、单峰突破、高位派发、变盘在即、回踩反抽等13种主力资金运作形态。</p>
          <img src="../../assets/images/activity/buyone365/img-p1-2.jpg" alt="">
        </dd>
        <dd>
          <p><em>3</em>主力筹码图下方为历史大单成本及成本价格分布。</p>
          <img src="../../assets/images/activity/buyone365/img-p1-3.jpg" alt="">
        </dd>
      </dl>
      <dl>
        <dt>实战运用</dt>
        <dd>
          <h3 class="dd-title">分时筹码追踪</h3>
          <div class="text">点击分时图右侧买卖队列即可切换至分时主力筹码追踪。尽管股价一度跌至低点，但从筹码追踪图可知，上方无套牢盘抛压，且有红色主力资金柱，主力于午后发力。</div>
          <img src="../../assets/images/activity/buyone365/img-p2.jpg" alt="">
        </dd>
      </dl>
      <h2 class="header-phone"><span>《双突战法》分时·高能突击信号</span></h2>
      <dl>
        <dt>实战运用</dt>
        <dd>
          <h3 class="dd-title">指标说明</h3>
          <div class="text">双突指标是一个分时预警指标，及时在盘中揭示主力的拉升异动。</div>
          <img src="../../assets/images/activity/buyone365/img-p3.jpg" alt="">
        </dd>
      </dl>
      <dl>
        <dt>信号预警</dt>
        <dd>
          <div class="text">可以查看当天出一突和双突信号的个股，辅助选股,也可以从一突双突个股数量与收益,研判市场的情绪。</div>
          <img src="../../assets/images/activity/buyone365/img-p4.jpg" alt="">
        </dd>
      </dl>
      <dl>
        <dt>附赠定制推送</dt>
        <dd>
          <div class="text">若您的自选股盘中触发“一突”、“二突”信号，系统将实时为您推送。</div>
          <img src="../../assets/images/activity/buyone365/img-p5.jpg" alt="">
        </dd>
      </dl>
      <dl>
        <dt>使用方法</dt>
        <dd>
          <div class="text">购买后，在个股K线图左下角【VIP决策】中打开开关，然后滑动到分时界面指标下即可查看双突信号、主力筹码追踪。</div>
          <img src="../../assets/images/activity/buyone365/img-p6.jpg" alt="">
        </dd>
      </dl>
    </div>
    <div class="buy-box">
      <span @click="goUrl(116)">立即抢购</span>
    </div>
  </div>
</template>

<script>
import AppHeader from "@/components/common/AppHeader.vue";
export default {
  components: {
    AppHeader,
  },
  data() {
    return {
      token: "",
      liData: ['逐笔交易','委托队列','历史回忆','资金流向','追击反转','抄底资金','双突战法','黄金坑2.0','TRT','短仓波动'],
      comIndex: 0,
      curIndex: 0
    };
  },
  created() {
    var token = this.$route.query.token;
    if (token) {
      this.token = token;
    }
  },
  methods: {
    changeComputer (i) {
      this.comIndex = i
      this.$refs.tabCon.style.left = (-1000 * i) + 'px'
      let items = document.querySelectorAll(".tab-con .item")
      console.log(this.$refs.tabMain)
      this.$refs.tabMain.style.height = items[i].offsetHeight + 'px'
    },
    goUrl(key) {
      let routerDate;
      if (this.token) {
        routerDate = this.$router.resolve({
          name: "ClientProduct",
          query: { token: this.token, pid: key },
        });
      } else {
        routerDate = this.$router.resolve({
          name: "OrderConfirm",
          params: { productId: key, month: 12 },
        });
      }
      let { href } = routerDate;
      window.open(href, "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
.buyone-wrap {
  background: url(../../assets/images/activity/buyone365/bg1.jpg) center 100px
      no-repeat,
    url(../../assets/images/activity/buyone365/bg2.jpg) center 730px no-repeat;
    padding-bottom: 138px;
  .auto {
    width: 1200px;
    height: 1280px;
    margin: 0 auto;
    .price {
      padding-top: 385px;
      margin-left: 230px;
      width: 750px;
      height: 150px;
      cursor: pointer;
      h2 {
        padding: 25px 0 0 60px;
        @include fc(80px, #fff);
        text-shadow: 0 2px 2px #d80048;
        line-height: 85px;
      }
      p {
        @include fc(24px, #fff);
        padding-left: 60px;
      }
    }
    .tel-top {
      margin: 50px 0 25px;
      text-align: center;
      @include fc(30px, #fff17a);
    }
    .mod-tab {
      overflow: hidden;
      .mod {
        border-radius: 30px;
        background: #fff;
        width: 580px;
        float: left;
        cursor: pointer;
        &:hover{
          box-shadow: 0 2px 5px #f00017;
          .title,
          .text {
            background: #fff;
          }
        }
        &.cur {
          box-shadow: 0 2px 5px #f00017;
          .title,
          .text {
            background: #fff;
          }
        }
        &:nth-child(2) {
          float: right;
          .title {
            img{
              margin-right: 60px;
            }
          }
          li strong {
            width: 235px;
            height: 50px;
            line-height: 50px;
            margin: 38px 0 38px 100px;
          }
          ul {
            position: relative;
            &:after {
              content: "";
              display: block;
              position: absolute;
              right: 0;
              bottom: 34px;
              background: url(../../assets/images/activity/buyone365/icon-give.png)
                no-repeat;
              width: 114px;
              height: 125px;
            }
          }
        }
        .title {
          background: #f2ccf7;
          height: 70px;
          padding: 15px 0;
          border-radius: 30px 30px 0 0;
          .con {
            background: linear-gradient(to bottom, #fd3194, #bf04d4);
            border-radius: 30px;
            height: 70px;
            line-height: 70px;
            @include fc(40px, #fff);
            margin: 0px 20px 15px;
          }

          img {
            vertical-align: middle;
            margin: 0 20px 0 30px;
          }
        }
        ul {
          background: linear-gradient(to bottom, #fd3194, #bf04d4);
          padding: 50px 0px 50px 60px;
          height: 300px;
          li {
            @include fc(40px, #fff);
            position: relative;
            line-height: 1;
            &:before {
              content: "";
              display: block;
              @include wh(14px, 14px);
              background: #fff;
              border-radius: 50px;
              position: absolute;
              left: -30px;
              top: 12px;
            }
            + li {
              margin-top: 15px;
            }
            span {
              display: block;
              background: rgba($color: #fff, $alpha: 0.23);
              font-size: 30px;
              margin-top: 10px;
              width: 410px;
              text-align: center;
              height: 40px;
              line-height: 40px;
            }
            strong {
              display: block;
              width: 280px;
              height: 60px;
              line-height: 60px;
              font-size: 30px;
              text-align: center;
              background: #ff892a;
              border-radius: 30px;
              margin: 40px 0 0 85px;
              text-shadow: 0 1px 2px #f00017;
            }
            em {
              font-size: 30px;
            }
          }
        }
        .text {
          border-radius: 0px 0px 30px 30px;
          @include fc(40px, #ba01d9);
          text-align: center;
          background: #f2ccf7;
          height: 70px;
          padding: 15px 0;
          line-height: 70px;
          em {
            font-size: 36px;
          }
          img {
            vertical-align: middle;
            position: relative;
            right: -50px;
          }
        }
      }
    }
  }
}
.phone-con{
  .header-phone{
    line-height: 94px;
    height: 94px;
    @include fc(48px, #fff);
    background: #585be8;
    span{
      width: 1200px;
      margin: 0 auto;
      display: block;
    }
  }
  dl{
    box-sizing: border-box;
    width: 1200px;
    margin: 50px auto 0;
    border: 2px solid #5a5df6;
    border-radius: 30px;
    dt{
      height: 85px;
      line-height: 85px;
      @include fc(48px, #595cf0);
      &:before{
        content: '';
        display: inline-block;
        width: 19px;
        height: 46px;
        background: linear-gradient(to bottom, #b6d2ff, #3e87ff);
        margin: -7px 40px 0 40px;
        vertical-align: middle;
      }
    }
    dd{
      padding: 30px 25px 40px;
      border-top: 2px solid #5a5df6;
      p{
        @include fc(36px, #595cf0);
        line-height: 48px;
        em{
          width: 60px;
          height: 60px;
          background: #5a5df6;
          text-align: center;
          line-height: 60px;
          color: #fff;
          border-radius: 50px;
          float: left;
          margin-right: 10px;
          margin-top: -6px;
        }
      }
      img{
        display: block;
        margin: 20px auto;
      }
      .dd-title{
        @include fc(36px, #5a5df6);
        margin-bottom: 15px;
      }
      .text{
        @include fc(36px, #191919);

      }
    }
  }
}
.buy-box{
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 138px;
  background: rgba($color: #fe8845, $alpha: 0.11);
  z-index: 9;
  span{
    background: linear-gradient(to bottom, #ffb45b, #fe4423);
    display: block;
    width: 355px;
    height: 90px;
    line-height: 90px;
    text-align: center;
    font-size: 48px;
    color: #fff;
    margin: 23px auto 0;
    border-radius: 50px;
    cursor: pointer;
  }
}
</style>
<style scoped>
.header-level2{width: 100%;height: 80px;background: #ff4d42;margin-bottom: 25px;}
.header-con{width: 1200px;margin:0 auto;line-height: 80px;color: #fff;}
.header-con h1{font-size: 40px;letter-spacing: 2px}
.header-con span{float: right;font-size: 24px;}
.conputer-wrap{width: 100%}
.main-con{width: 1200px;margin:0 auto;padding-bottom: 30px;}
.main-con .times{margin-bottom: 8px;font-size: 14px;}
.pankou{background: #f9f9f9;border-left: 1px solid #f0f0f0;border-right: 1px solid #f0f0f0;border-top: 2px solid #ff4d42;
	border-bottom:2px solid #ff4d42;padding:20px 0}
.pankou-l{float: left;width: 510px}
.pankou-l-table{width:200px;border: 1px solid #c00000;position: relative;margin:0 auto;}
.pankou-l-table .border-top{position: absolute;right: -8px;top:20px;width:212px;height: 20px;border: 2px solid #08aef9}
.pankou-l-table .border-btm{position: absolute;right: -8px;bottom:-2px;width:212px;height: 20px;border: 2px solid #08aef9}
.pankou-l-table .line-l{position: absolute;left: -80px;top:53px;width:78px;height: 417px;border:1px solid #c00000;
	background: #f9f9f9;border-right: 0}
.pankou-l-table .info-l{position: absolute;left: -138px;top:206px;width:98px;background: #f9f9f9;border: 1px solid #c00000;
padding:10px;color: #c00000;font-size: 14px}
.pankou-l-table .line-r{position: absolute;right: -80px;top:53px;width:78px;height: 417px;border:1px solid #08aef9;
	background: #f9f9f9;border-left: 0}
.pankou-l-table .info-r{position: absolute;right: -150px;top:180px;width:108px;background: #f9f9f9;border: 1px solid #08aef9;
padding:10px;color: #0096da;font-size: 14px}
.pankou .title{font-size: 18px;color: #ff4d42;margin:0px 0px 15px 20px;padding-left: 35px;position: relative;}
.pankou .title:after{content: '';display: block;width: 20px;height: 20px;border-radius: 10px;background: #ff4d42;position: absolute;
left: 0;top:3px;}
.gray{color: #c0c0c0;}
.pankou table{width: 200px;font-family: Arial,SimSun, "宋体"}
.pankou table th,.pankou table td{height: 22px;line-height: 22px;background: #000;color: #ffff52;
	font-size: 16px;}
.pankou table th{font-size: 18px;}
.pankou table th span{color: #52ffdb}
.pankou table td span{font-size: 14px;}
.pankou table td{text-align: right}
.pankou table td:first-child{text-align: left;padding-left: 3px;color: #c0c0c0}
.pankou table td:last-child{padding-right: 2px;}
.pankou table td.w1{width: 35px;font-size: 16px;}
.pankou table td.w2{width: 50px;}
.pankou table td.w3{width: 40px;color: #c0c0c0;}
.pankou table tr.border-b{border-bottom: 1px solid #c00000}
.pankou table.l-con td.first-child{width: 50px;}
.pankou table.l-con td.w2{width: 60px;}
.pankou-chart{float: right;width: 385px;background: #fff;border: 1px solid #c00000;}
#today-chart{border-bottom: 1px solid #c00000;}
#today-chart,#fiveday-chart{width: 380px;height: 238px;}
.pankou-chart p{height: 30px;line-height: 30px;background: #ff4d42;color: #fff;font-size: 14px;text-align: center;}
.l2-pankou{margin-left: 55px;border: 1px solid #c00000;padding:2px;height: 44px;background: #fff}
.l2-pankou span{display: block;float: left;width: 100px;height: 44px;line-height: 44px;color: #fff;background:#07a1e6;font-size: 18px;
	text-align: center;margin-right: 15px;}
.l2-pankou p{font-size: 14px;color: #000;line-height: 18px;margin-top: 5px;}
.pankou-r{float: right;width: 480px}
.pankou-r .text{width: 290px;padding:3px 5px;margin-left: 55px;border: 1px solid #07a1e6;color: #0096da;font-size: 14px;}
.pankou .pankou-r .title{color: #07a1e6}
.pankou .pankou-r .title:after{background: #07a1e6}
.pankou .pankou-r .pankou-l-table{width: 230px;margin-left: 55px;}
.pankou table.r-con{width: 230px;}
.pankou table.r-con th{font-size: 16px;font-weight: normal;text-align: center;color: #52ffff;border-bottom: 1px solid #c00000}
.pankou table.r-con td:first-child{width: 23px;text-align: right;padding-right:10px;}
.pankou table.r-con td.w2{width: 75px;text-align: left;padding-left: 3px;}
.pankou table.r-con td.w3{width: 60px;}
.pankou .buy-btn{display: block;width: 250px;height: 60px;text-indent: -99999em;background: url(../../assets/images/activity/buyone365/buy-btn1.png) no-repeat 0 0;
margin:40px auto 10px;}
/*.pankou .buy-btn:hover{background-position: 0 -202px;}*/
.mid-bar1{margin:30px 0;}
.pankou-r .pankou-l-table .line-r{top:32px;height: 419px;}
.pankou-r .pankou-l-table .info-r{width: 72px;right: -127px;}
/*tab切换*/
.tab-tit{height: 30px;margin-bottom: 10px;}
.tab-tit ul li{float: left;width: 88px;height:28px;background: #ffba62;color: #17161e;margin-right: 12px;border: 1px solid #ffa83a;
line-height: 30px;text-align: center;cursor: pointer;transition: all 0.5s;}
.tab-tit ul li:nth-child(n+5){margin-right: 10px;background: #ffe4a0;border: 1px solid #ffc534}
.tab-tit ul li:last-child{margin-right: 0;}
.tab-tit ul li.lir{margin-right: 10px;background: #ffe4a0;border: 1px solid #ffc534}
.tab-tit ul li.mr0{margin-right: 0;}
.tab-tit ul li.cur{background: #ff4d42;border: 1px solid #ff4d42;color: #fff;margin-top:10px;}
.tab-main{width: 1000px;overflow: hidden;position: relative;height: 1651px;border-top: 2px solid #ff4d42;border-bottom: 2px solid #ff4d42;}
.tab-con{width: 10000px;position: absolute;left: 0;top:0;transition: all 0.5s;}
.tab-con .item{padding:20px 20px 0 20px;float: left;width: 958px;border-left: 1px solid #efefef;border-right: 1px solid #efefef;background: #f9f9f9;}
.tab-con .item dl dt{font-size: 18px;color: #17161e;margin:0px 0px 15px 0px;padding-left: 30px;position: relative;}
.tab-con .item dl dt:after{content: '';display: block;width: 20px;height: 20px;border-radius: 10px;background: #ff4d42;position: absolute;
left: 0;top:3px;}
.tab-con .item dl dd{padding-bottom: 30px;border-bottom: 1px solid #d0d0d0;margin-bottom: 30px;}
.tab-con .item dl dd img{display: block;margin-left: 30px;}
.tab-con .item dl dd img.ml0{margin-left: 0px;}
.tab-con .item dl dd img.mauto{margin:auto;}
.mb30{margin-bottom: 30px;}
.tab-con .item dl dd.border-none{border-bottom: none;margin-bottom: 0px;}
.tab-con .item dl dd p{padding-left: 22px;margin:0 0 20px 8px;font-size: 14px;color: #17161e;position: relative;line-height: 24px;}
.tab-con .item dl dd p.title:before{position: absolute;left: 0;top:5px;display: block;content: '';width: 12px;height: 12px;background: url(../../assets/images/activity/buyone365/star.png) no-repeat;}
.tab-con .item dl dd p.mb0{margin-bottom: 0;}
.blue{color: #07a1e6}
.tel{position:fixed;top:131px;right: 50%;margin-right: -600px;width: 32px;height: 258px;}
.auto-computer{width: 1000px;margin: 0 auto;}
</style>


// WEBPACK FOOTER //
// src/pages/activity/BuyOne202104.vue